<script setup>
const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false
  },
  severity: {
    type: String,
    default: () => 'primary',
    validator(value) {
      return ['primary', 'secondary', 'tertiary'].includes(value)
    }
  },
  type: {
    type: String,
    default: () => null,
    validator(value) {
      return ['submit', 'reset'].includes(value)
    }
  },
  to: {
    type: String,
    default: () => null
  },
  form: {
    type: String,
    default: () => null
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const submitValue = computed(() => {
  if (props.type) {
    return props.type
  }

  return !!props.form ? 'submit' : null
})

const itemClasses = computed(() => {
  return [
    props.severity,
    {
      disabled: props.disabled
    }
  ]
})
</script>

<template>
  <button
    v-if="!props.to"
    class="p-2"
    :disabled="props.disabled"
    :type="submitValue"
    :form="props.form"
    :class="itemClasses"
    v-bind="$attrs"
  >
    <i
      v-if="props.loading"
      class="pi pi-spin pi-spinner mr-2"
      style="font-size: 1rem;"
    />
    <i v-if="props.icon && !props.loading" class="pi mr-2" :class="props.icon" style="font-size: 1rem"/>
    <slot>
      {{ props.label }}
    </slot>
  </button>
  <NuxtLink
    v-if="props.to"
    class="p-2"
    :to="props.to"
    :class="itemClasses"
    v-bind="$attrs"
  >
    <i v-if="props.icon" class="pi mr-2" :class="props.icon" style="font-size: 1rem"/>
    <slot>
    {{ props.label }}
    </slot>
  </NuxtLink>
</template>

<style scoped lang="scss">
.primary {
  @apply text-white text-[0.9rem] lg:text-[1rem] italic bg-red-800 hover:bg-red-800 px-2 py-1 cursor-pointer font-bold;

  &.active, &.router-link-active {
    @apply bg-black;
  }

  &.disabled {
    @apply cursor-not-allowed opacity-75 hover:bg-red-800;
  }
}

.secondary {
  @apply text-white text-[0.9rem] lg:text-[1rem] italic bg-black hover:bg-black px-2 py-1 cursor-pointer font-bold;

  &.active, &.router-link-active {
    @apply bg-white text-black;
  }

  &.disabled {
    @apply cursor-not-allowed opacity-75 hover:bg-black;
  }
}

.tertiary {
  @apply text-[#363330] hover:text-[#363330] text-[0.9rem] lg:text-[1rem] font-bold italic bg-[#dcd6ce] hover:bg-[#dcd6ce] px-2 py-1 cursor-pointer;

  &.active, &.router-link-active {
    @apply bg-red-800 text-white;
  }

  &.disabled {
    @apply cursor-not-allowed opacity-75 hover:bg-white;
  }
}
</style>
